// 문자열 중 숫자만 반환하는 유틸 함수
export const numberonly = (val: string | number): string => {
	if (typeof val === 'number') return String(val);
	else if (typeof val === 'string') return val.replace(/[^\d]/g, '');
	else return '';
};

// 숫자에 3자리마다 ',' 넣어주는 유틸 함수
export const numberFormat = (num?: string | number): string => {
	if (typeof num === 'string') {
		return new Intl.NumberFormat().format(Number(numberonly(num)));
	} else if (typeof num === 'number') {
		return new Intl.NumberFormat().format(num);
	} else {
		return '-';
	}
};

// 숫자에 3자리마다 ',' 넣어주고 소수점 처리를 포함한 유틸 함수
export const numberFormatWithDecimal = (num?: string | number): string => {
	if (typeof num === 'string') {
		return Number(num).toLocaleString('en-US', { maximumFractionDigits: 20 });
	} else if (typeof num === 'number') {
		return num.toLocaleString('en-US', { maximumFractionDigits: 20 });
	} else {
		return '-';
	}
};

export const priceFormat = (num: number | string): string => {
	if (typeof num === 'number') {
		return new Intl.NumberFormat().format(num);
	}
	return '-';
};

// 전화번호 사이에 -(dash) 넣어주는 유틸 함수
export const phoneFormat = (phoneNum: string) => {
	if (typeof phoneNum !== 'string') return '';
	const val = phoneNum.replace(/[^0-9]*/s, ''); //숫자이외 제거

	if (val.substring(0, 2) == '02') {
		return phoneNum.replace(/[^0-9]/g, '').replace(/([0-9]{2})([0-9]{3,4})([0-9]{4})$/g, '$1-$2-$3');
	} else if (
		val.substring(0, 2) == '8' ||
		val.substring(0, 2) == '15' ||
		val.substring(0, 2) == '16' ||
		val.substring(0, 2) == '18'
	) {
		return phoneNum.replace(/[^0-9]/g, '').replace(/([0-9]{4})([0-9]{4})$/g, '$1-$2');
	} else {
		return phoneNum
			.replace(/[^0-9]/g, '')
			.replace(/([0-9]{3})([0-9]{3,4})([0-9]{4})$/g, '$1-$2-$3')
			.replace(/(\-{1,2})$/g, ''); //eslint-disable-line
	}
};

// 사업자 번호 사이에 -(dash) 넣어주는 유틸 함수
export const businessNumFormat = (bizNumber: string) => {
	if (typeof bizNumber !== 'string') return '';

	return bizNumber
		.replace(/[^0-9]/g, '')
		.replace(/([0-9]{3})([0-9]{2})([0-9]{5})$/g, '$1-$2-$3')
		.replace(/(\-{1,2})$/g, ''); //eslint-disable-line
};

// + 단위 추가하는 함수
export const formatWithSign = (rate: string) => {
	if (Number(rate) > 0) return `+${rate}`;
	else return rate;
};

// 특수 문자를 언더바로 변환하는 함수(특수문자가 포함된 문자열을 value로 사용하여 값을 구분할 때 필요)
export const replaceSpecialCharsWithUnderbar = (text: string) => {
	return text.replace(/[^a-zA-Z0-9가-힣]/g, '_');
};
export const replaceUnderscoreWithSpace = (str: string) => {
	return str.replace(/_/g, ' ');
};

export const removeTimeFromDate = (dateTimeString: string) => {
	return dateTimeString.split(' ')[0];
};
